export default "__VITE_ASSET__CXygYD6G__"